/** Storefront where an item was first saved, independent of product membership. */
export type SourceSection = 'main' | 'bazaar' | 'used';

export interface ItemSource {
  /** Null/absent for legacy items whose origin is unknown. */
  source_section?: SourceSection | null;
}
